import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '@app/core/services/environment.service';
import { Observable } from 'rxjs';
import { api_routes } from '@app/consts';

const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class CultureConfigurationService {

  constructor(private http: HttpClient, private envService: EnvironmentService) { }

  getCultureConfiguration(): Observable<any> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.CULTURES}/${api_routes.SYSTEM_CULTURES}`, {
      headers: headers
    })
  }

  saveCultureConfiguration(formData: any): Observable<any> {
    return this.http.put<any>(`${this.envService.env.apiUrl}${api_routes.CULTURES}/${api_routes.SYSTEM_CULTURES}`, formData, {
      headers: headers
    })
  }
}


